export default "<!-- <p>Adacco43 je to 010</p> -->\n\n<router-outlet></router-outlet>"